import {
  button_default
} from "./chunk-4RZJ54WQ.js";

// src/controls/popover/popover.tsx
import { trackEvent } from "@a24/analytics";
import { useId } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Popover = ({
  className,
  id,
  children,
  buttonProps,
  buttonContent,
  closeButtonContent,
  popover = "auto",
  closeButtonProps,
  ref
}) => {
  const popoverId = useId();
  return /* @__PURE__ */ jsxs("div", { id, children: [
    /* @__PURE__ */ jsx(
      button_default,
      {
        ...buttonProps,
        onClick: () => trackEvent({
          name: "button_interaction",
          data: { value: "Popover|Open" }
        }),
        popoverTarget: popoverId,
        children: buttonContent || "Open Popover"
      }
    ),
    /* @__PURE__ */ jsxs("div", { ref, className, popover, id: popoverId, children: [
      closeButtonContent && /* @__PURE__ */ jsx(
        button_default,
        {
          ...closeButtonProps,
          onClick: () => trackEvent({
            name: "button_interaction",
            data: { value: "Popover|Close" }
          }),
          popoverTarget: popoverId,
          children: closeButtonContent || "Close Popover"
        }
      ),
      children
    ] })
  ] });
};
var popover_default = Popover;

export {
  popover_default
};
